module.exports = __webpack_public_path__ + "img/mind_skeleton_103.b8aae66c.png";